import React, { createContext, useReducer } from 'react';
import useWindowDimension from '../effects/useWindowDimension.effect';

import {
  playerReducer,
  SET_VOLUME,
  SET_PLAYBACK_RATE,
  SET_MINIMIZED
} from '../reducers/player.reducer';

export const PlayerContext = createContext();

const PlayerContextProvider = ({ children }) => {
  const { width, height } = useWindowDimension();
  const [playerState, dispatch] = useReducer(playerReducer, {
    volume: 1,
    playbackRate: 1,
    minimized: width < 800 || height < 700 ? true : false
  });

  const setVolume = volume => {
    dispatch({ type: SET_VOLUME, payload: volume });
  };

  const setPlaybackRate = speed => {
    dispatch({ type: SET_PLAYBACK_RATE, payload: speed });
  };

  const setMinimized = minimized => {
    dispatch({ type: SET_MINIMIZED, payload: !playerState.minimized });
  };

  return (
    <PlayerContext.Provider
      value={{
        volume: playerState.volume,
        playbackRate: playerState.playbackRate,
        minimized: playerState.minimized,
        setVolume,
        setPlaybackRate,
        setMinimized
      }}
    >
      {children}
    </PlayerContext.Provider>
  );
};

export default PlayerContextProvider;
